type TokenType = 'key' | 'string' | 'number' | 'boolean' | 'other'

interface Token {
  type: TokenType
  value: string
}

function tokenizeLine(line: string): Token[] {
  const tokens: Token[] = []
  let remaining = line

  while (remaining.length > 0) {
    const strMatch = remaining.match(/^"(?:[^"\\]|\\.)*"/)
    if (strMatch) {
      const after = remaining.slice(strMatch[0].length).trimStart()
      tokens.push({ type: after.startsWith(':') ? 'key' : 'string', value: strMatch[0] })
      remaining = remaining.slice(strMatch[0].length)
      continue
    }

    const numMatch = remaining.match(/^-?\d+\.?\d*/)
    if (numMatch) {
      tokens.push({ type: 'number', value: numMatch[0] })
      remaining = remaining.slice(numMatch[0].length)
      continue
    }

    const boolMatch = remaining.match(/^(true|false|null)/)
    if (boolMatch) {
      tokens.push({ type: 'boolean', value: boolMatch[0] })
      remaining = remaining.slice(boolMatch[0].length)
      continue
    }

    tokens.push({ type: 'other', value: remaining[0] })
    remaining = remaining.slice(1)
  }

  return tokens
}

const TOKEN_COLORS: Record<TokenType, string> = {
  key: 'text-sky-700',
  string: 'text-emerald-700',
  number: 'text-amber-600',
  boolean: 'text-purple-600',
  other: 'text-gray-500',
}

interface Props {
  json: string
}

export default function JsonViewer({ json }: Props) {
  const lines = json.split('\n')

  return (
    <div className="overflow-auto font-mono text-xs leading-6 select-text">
      {lines.map((line, i) => (
        <div key={i} className="flex hover:bg-gray-100/60">
          <span className="w-10 text-right pr-4 text-gray-400 select-none tabular-nums shrink-0">
            {i + 1}
          </span>
          <span className="whitespace-pre text-gray-500">
            {tokenizeLine(line).map((tok, j) => (
              <span key={j} className={TOKEN_COLORS[tok.type]}>{tok.value}</span>
            ))}
          </span>
        </div>
      ))}
    </div>
  )
}
